import { render, staticRenderFns } from "./RevisionInvalid.vue?vue&type=template&id=7be71c40&"
import script from "./RevisionInvalid.vue?vue&type=script&lang=js&"
export * from "./RevisionInvalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports